import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import SingleProductPageContext from './Context/SingleProductPageContext';
import SingleCategoryPageContext from './Context/SingleCategoryPageContext';
import CartContext from './Context/CartContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CartContext>
      <SingleProductPageContext>
        <SingleCategoryPageContext>
          <App />
        </SingleCategoryPageContext>
      </SingleProductPageContext>
    </CartContext>
  </React.StrictMode>
);